import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2561">
      <Navbar data-id="element-2562" />
      <main data-id="element-2563">
        <ConsularAffairs data-id="element-2564" />
      </main>
      <Footer data-id="element-2565" />
      <FeedbackPopup data-id="element-2566" />
    </div>;
}